export const ICONPATH = {
    // "": `${process.env.PUBLIC_URL}/assets/assets/icons/.png`,
    home: require('../assets/icons/home.png'),
    print: require('../assets/icons/print.png'),
    mail: require('../assets/icons/mail.png'),
    boxD: require('../assets/icons/boxDoor.png'),
    drone: require('../assets/icons/drone.png'),
    checkList: require('../assets/icons/checkList.png'),
    checkListW: require('../assets/icons/checkListW.png'),
    delivery: require('../assets/icons/deliveryCar.png'),
    building: require('../assets/icons/building.png'),
    boxF: require('../assets/icons/boxfact.png'),
    airplane: require('../assets/icons/airplaneBox.png'),
    storage: require('../assets/icons/storage.png'),
    boxH: require('../assets/icons/boxFor.png'),
    nav: require('../assets/icons/nav.png'),
    close: require('../assets/icons/close.png'),
}